import React,{Component} from 'react';
import { NavLink } from 'react-router-dom';

import Footer from './partials/footer';
//import './home4.css';


class Blockproducers extends React.Component {
   componentWillMount () {
  
       const link  = document.createElement('link');
    
    link.rel  = 'stylesheet';
    link.type = 'text/css';
    link.href = '/assets/styles/home4.css?v=202421';
    
    //document.head.appendChild(link);

      
    }
   render(){
 
    return(
        <div class="gmxpage block newpagedesign home4 homenewdesignload workpointhomepage">
            <div class="flex-section dark-gradient wf-section hed">
                <div class="flex-section">
                    <div data-collapse="medium" data-animation="default" data-duration="800" data-easing="ease-in-cubic" data-easing2="ease-out-quart" role="banner" class="navbarnew transparentbg w-nav">
                        <div class="nav-container w-container">
                            <a href="/" class="nav-logo w-inline-block"><img src="/assets/images/home4/logo_home.png" width="250" alt="" class="logo-5" /></a>
                            <nav role="navigation" class="navmenulinks w-nav-menu">
                                <div class="nav-menu homehidden">
                                    <div data-hover="true" data-delay="0" class="dropdown w-dropdown hjk">
                                        <div class="navlink-dropdown whitetext w-dropdown-toggle" id="w-dropdown-toggle-0" aria-controls="w-dropdown-list-0" aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0">
                                            <div class="chevrondown w-icon-dropdown-toggle" aria-hidden="true"></div>
                                            <div class="text-block">By Role</div>
                                        </div>
                                        <nav class="dropdown-list w-dropdown-list" id="w-dropdown-list-0" aria-labelledby="w-dropdown-toggle-0">
                                            <div class="dropdownnavlinks">
                                                <a href="/designer" class="dropdownlink w-dropdown-link" tabindex="0">For Designers</a><a href="/teams" class="dropdownlink w-dropdown-link" tabindex="0">For Teams</a>
                                                <a href="/developer" class="dropdownlink w-dropdown-link" tabindex="0">For Developers</a>
                                            </div>
                                        </nav>
                                    </div>
                                    <div data-hover="true" data-delay="0" class="dropdown w-dropdown hjk">
                                        <div class="navlink-dropdown whitetext hide w-dropdown-toggle" id="w-dropdown-toggle-1" aria-controls="w-dropdown-list-1" aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0">
                                            <div class="chevrondown w-icon-dropdown-toggle" aria-hidden="true"></div>
                                            <div class="text-block">By Channel</div>
                                        </div>
                                        <nav class="dropdown-list w-dropdown-list" id="w-dropdown-list-1" aria-labelledby="w-dropdown-toggle-1">
                                            <div class="dropdownnavlinks">
                                                <a href="/create-alexa-skill" class="dropdownlink w-dropdown-link" tabindex="0">Alexa Skills</a>
                                                <a href="/create-google-action" class="dropdownlink w-dropdown-link" tabindex="0">Google Actions</a><a href="/ivr-builder" class="dropdownlink w-dropdown-link" tabindex="0">IVR's</a>
                                                <a href="/chatbots" class="dropdownlink w-dropdown-link" tabindex="0">Chatbots</a><a href="/in-car-assistant" class="dropdownlink w-dropdown-link" tabindex="0">In-car Assistants</a>
                                                <a href="/in-app-assistant" class="dropdownlink w-dropdown-link" tabindex="0">In-app Assistants</a>
                                            </div>
                                        </nav>
                                    </div>
                                    <div data-hover="true" data-delay="0" class="dropdown w-dropdown hjk">
                                        <div class="navlink-dropdown whitetext w-dropdown-toggle" id="w-dropdown-toggle-2" aria-controls="w-dropdown-list-2" aria-haspopup="menu" aria-expanded="false" role="button" tabindex="0">
                                            <div class="chevrondown w-icon-dropdown-toggle" aria-hidden="true"></div>
                                            <div class="text-block">Resources</div>
                                        </div>
                                        <nav class="dropdown-list w-dropdown-list" id="w-dropdown-list-2" aria-labelledby="w-dropdown-toggle-2">
                                            <div class="dropdownnavlinks">
                                                <a href="#" target="_blank" class="dropdownlink w-dropdown-link" tabindex="0">Documentation</a>
                                                <a href="#" class="dropdownlink w-dropdown-link" tabindex="0">Tutorials</a>
                                                <a href="#" target="_blank" class="dropdownlink w-dropdown-link" tabindex="0">Community</a>
                                                <a href="/events" class="dropdownlink w-dropdown-link" tabindex="0">Events</a><a href="/blog" class="dropdownlink w-dropdown-link" tabindex="0">Blog</a>
                                            </div>
                                        </nav>
                                    </div>
                                    
                                    
                                    
                                </div>
                                <div class="navcta">
                                <NavLink to="/services" class="navlink-button sign-in whitesignin w-nav-link hjk">Services</NavLink>
                                <NavLink to="/testimonials" class="navlink-button sign-in whitesignin w-nav-link hjk">Testimonials</NavLink> 
                                
                                <NavLink to="/login" class="navlink-button sign-in whitesignin w-nav-link hjk">Log In</NavLink>
                                
                                <a href="/signup" class="btn-lg btn-flat btn-outline ml-3 desk getnewhome" >Get Started</a>
                                    
                                </div>
                            </nav>
                            <div
                                data-w-id="1f0a3c8a-cfce-9696-ae5e-34322a4a1337"
                                class="menu-button w-nav-button gq"
                                
                                aria-label="menu"
                                role="button"
                                tabindex="0"
                                aria-controls="w-nav-overlay-0"
                                aria-haspopup="menu"
                                aria-expanded="false"
                            >
                                <img src="/assets/images/home4/5fd6310ed7b9bf44c616bd44_Menu%20Icon.svg" loading="lazy" width="24" alt="" class="menu-icon" />
                                <div class="menuline-top"></div>
                                <div class="menuline-top-center"></div>
                                <div class="menuline-top-bottom"></div>
                            </div>
                        </div>
                        <div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div>
                    </div>
                    <div class="container designhero">
                        <div
                            data-w-id="5ef28095-4fc7-2e3f-62d0-0a2056a773a1 zs"
                           
                            class="gradientext-wrapper herotopmargin"
                        >
                            <h2 class="designertab-h2 hometopzero hide">Who&nbsp;Is</h2>
                        </div>
                        <h1
                            data-w-id="5ef28095-4fc7-2e3f-62d0-0a2056a773a4 zs"
                           
                            class="bigheading whitebig-h1 herovers onew"
                        >
                            ROYALTY TAX
                        </h1>
                       <p data-w-id="5ef28095-4fc7-2e3f-62d0-0a2056a773a8 zs" class="designer-p1 designhero whitep1 ">
                        Entrepreneur-focused firm that knows what it’s like to build and scale a business from scratch<span class="mobileview"></span>
                       <span class="dfh"> Entrepreneur-focused firm that knows what it’s like to  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;build and scale a business from scratch </span>
                       </p>
                         
                        <div
                            data-w-id="5ef28095-4fc7-2e3f-62d0-0a2056a773aa zs"
                            
                            class="hero-cta getstarted"
                        >
                            <a href="/signup" class="fill singlemarginzero w-inline-block homebh ">Consultation
                            <svg focusable="false" class="ibm-duo-u--link-icon--arrow-right" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" slot="icon"><path d="M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"></path></svg>
                            </a>
                        </div>
                    </div>
                  
                </div>
            </div>
	
             <div class="logodiv flex-section channels">
                    <h4 class="build">Technology Providers</h4>
                    <p>Our suite of technology tools that power Royalty Tax</p>
                  
                    <div class="img-box2 newd">
                   <img src="/assets/images/royalty_ramp_log.png" alt=""  />
                </div>
                    <div class="img-box2 newd">
                   <img src="/assets/images/royalty_gusto_logo_new.png" alt=""  />
                </div>
                 <div class="img-box2 newd taxdome">
                   <img src="/assets/images/royalty_taxdome_logo.png" alt=""  />
                </div>

               
               
                <div class="img-box2 newd taxdome">
                    <img src="/assets/images/royalty_xero_logo.png" alt=""  />
                </div>
                

                
                <img src="/assets/images/home4/602f1896fb75bb414460c109_Shape-3.svg" loading="lazy" width="350" alt="" class="absolutebg-40" />
                </div>
                
                
                <div class="connecting-trends first-trends f1 hide">
         <div class="container">
            <div class="row align-items-center rotate-in-mobile">
            <div class="col-md-6">
            <img src="/assets/images/blue_arch.png" loading="lazy" width="350" alt="" class="absolutebg-40 ko" />

            <div class="card_area blocksectionbottom ">
            
           
                           
                        

                         
                           <div class="card_area_box d-none">
                               <div class="row box-heading-row align-items-start perc_box m-sm">
                                   <span class="rate-text new30"><div>40</div></span><span class="percent">%</span>
                               </div>
                               <div class="row m-sm nj">
                                 <div class="col">
                                   <h5 class="m-0 no-bg mrate yield-box-padding">Lorem Ipsum</h5>
                                 </div>
                               </div>

                               <div class="row m-sm no-gutters yield-buttons-container">
                                 
                                 <button id="yield-btn-1-1" class="button mt-0 mb-0 yield-rate-btn mr-6 active">5+ Employees</button>
                                 <button id="yield-btn-1-2" class="button mt-0 mb-0 yield-rate-btn mr-6">25+ Employees</button>
                                 
                               </div>

                               <div class="row">
                                 <div class="col">
                                   <h3 class="yield-box-padding card_area_subheading">Lorem Ipsum</h3>
                                 </div>
                               </div>

                               <div class="row m-md">
                                 <div class="col">
                                   <span><div class="yield-box-padding">Lorem Ipsum has been the industry's.<a href="javascript:void(0);"><img src="/assets/images/info_icon.png" class="clickinfoimg" /></a></div></span>
                                 </div>
                               </div>

                               <div class="row disclosure-row">
                                 <div class="col">
                                   <div class="yield-box-padding"><span class="extra-small syu"><div><span>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</span></div></span></div>
                                 </div>
                               </div>

                           </div>

                          
                           <div class="card_area_box">
                               <div class="row box-heading-row align-items-start perc_box m-sm">
                                   <span class="rate-text new30"><div>30</div></span><span class="percent">%</span>
                               </div>
                               <div class="row m-sm nj">
                                 <div class="col">
                                   <h5 class="m-0 no-bg mrate yield-box-padding">Lorem Ipsum</h5>
                                 </div>
                               </div>

                               <div class="row m-sm no-gutters yield-buttons-container">
                                
                                 <button id="yield-btn-2-1" class="button mt-0 mb-0 yield-rate-btn mr-6">5+ Employees</button>
                                 <button id="yield-btn-2-2" class="button mt-0 mb-0 yield-rate-btn mr-6 active">25+ Employees</button>
                                 
                               </div>

                               <div class="row">
                                 <div class="col">
                                   <h3 class="yield-box-padding card_area_subheading">Lorem Ipsum</h3>
                                 </div>
                               </div>

                               <div class="row m-md">
                                 <div class="col">
                                   <span><div class="yield-box-padding">Lorem Ipsum is simply dummy text of the printing.<a href="javascript:void(0);"><img src="/assets/images/info_icon.png" class="clickinfoimg" /></a></div></span>
                                 </div>
                               </div>

                               <div class="row disclosure-row">
                                 <div class="col">
                                   <div class="yield-box-padding"><span class="extra-small syu"><div><span>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. </span></div></span></div>
                                 </div>
                               </div>

                           </div>

                          
                           

                       </div>
           
                     </div>
            
            
            <div class="col-md-6">
               <div class="section-content">
               <h2 class="heading-3"> <span class="eyebrow">Why do we use it?</span> 
               </h2>
                <h2>Royalty manages your<br/> company specific Tax and <br/>employment filings in our<br/> touchpoint portal</h2>
                  
                <div class="upperd">
                     <p class="cta-link link"><a href="/signup" class="btn-link">Initiate Consultation&nbsp; </a></p>
                     </div>
               </div> </div>
            </div>

            </div>
      </div>
       

      <div class="connecting-trends sect" >
         <div class="container">
            <div class="row align-items-center">
               <div class="col-md-6">
                  <div class="section-content">
                  <h2 class="heading-3 hide"> <span class="eyebrow">Tech Stack</span> 
               </h2>
                  <h2>Powering your Books <br/>with best in class<br/> technology</h2>
                    <div class="upperd">
                     <p class="cta-link link"><a href="/signup" class="btn-link">Start Consultation&nbsp; </a></p>
                     </div>
                  </div>
               </div>
               <div class="col-md-6">
                  <div class="logo-list">
                     <div class="row c-home-notifications workpointne">
                        <div class="col-12 col-md-12">
                           <div class="logo-wrap"><img src="/assets/images/home4/product_xero-accounting-software_overview.1646877536652.webp" alt="Outreachintegration" /></div>
                        </div>
                       
                       
                       
                     </div>
                  </div>
             </div>
            </div>
         </div>
         <div class="grid triangle-pattern">
    <div class="triangle one" ></div>
    <div class="triangle one2" ></div>
    <div class="triangle " ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle"></div>
    <div class="triangle" ></div>
    <div class="triangle animated blue-2" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle animated blue-2"></div>
    <div class="triangle"></div>
    <div class="triangle animated blue-2" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle animated blue-1"></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle animated blue-1"></div>
    <div class="triangle animated blue-1"></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle animated blue-1"></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
    <div class="triangle" ></div>
  
    <div class="triangle animated blue-1"></div>
    </div>
               
      </div>
    <div class="framer-JQ33n" id='ds'>
      <div class="framer-navnro container" data-framer-name="Callendly" name="Callendly">
                   
                    <div class="framer-k4rxum">
                        <div class="framer-a0qkzg" >
                            <div class="ssr-variant hidden-v14nzn">
                                <div class="framer-84phap"  data-framer-component-type="RichTextContainer">
                                    <h1
                                       
                                        class="framer-text h1fm"
                                    >
                                       Royalty Tax Onboarding <br/>Process
                                    </h1>
                                </div>
                            </div>
                            <div class="ssr-variant hidden-v14nzn hide" >
                                <div class="framer-12du1bp"  data-framer-component-type="RichTextContainer">
                                    <h2
                                        
                                        class="framer-text ghme"
                                    >
                                        What you should know about us
                                    </h2>
                                </div>
                            </div>
                            <div class="upperd">
                     <p class="cta-link link"><a href="/signup" class="btn-link">Schedule Consultation&nbsp; </a></p>
                     </div>
                        </div>
                        <div class="framer-afw8n8">
                            <div class="framer-do2lk3" >
                                <div class="framer-a1rphk sectiononeb show" data-framer-name="Card" id="section-1" name="Card" >
                                    <div class="framer-laafcp "  data-framer-component-type="RichTextContainer">
                                        <h3
                                            
                                            class="framer-text rict"
                                        >
                                            <span>1</span> 
                                        </h3>
                                    </div>
                                    <div class="framer-k9z80w "  data-framer-component-type="RichTextContainer">
                                        <h3
                                            
                                            class="framer-text ghme1"
                                        >
                                            Video Call 
                                        </h3>
                                    </div>
                                    <div class="framer-rof8e4"  data-framer-component-type="RichTextContainer">
                                            <p
                                               
                                                class="framer-text ghme1"
                                            >
                                               We like to understand who our clients are and what they need from us. We also want to know the level of care they have received in the past and what they want from us.
                                            </p>
                                        </div>
                                   
                                   
                                    
                                </div>
                            </div>
                            <div class="framer-1ka9yz0 sectiononeb" data-framer-name="Card" id="section-2" name="Card" >
                                <div class="framer-794u9d">
                                    <div class="framer-15md0oe"  data-framer-component-type="RichTextContainer">
                                        <h3
                                           
                                            class="framer-text rict"
                                        >
                                            <span>2</span> 
                                        </h3>
                                    </div>
                                    <div class="framer-ffi5rs">
                                       <div class="framer-n6dn7u"  data-framer-component-type="RichTextContainer">
                                            <h3
                                               
                                                class="framer-text ghme1"
                                            >
                                                  Quote & Engagement
                                            </h3>
                                        </div>
                                        <div class="framer-rof8e4"  data-framer-component-type="RichTextContainer">
                                            <p
                                               
                                                class="framer-text ghme1"
                                            >
                                               Using information from our video call we will let you know what it will cost to use our services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="framer-22qcqv sectiononeb" data-framer-name="Card" id="section-3" name="Card" >
                                <div class="framer-1gnp73m">
                                    <div class="framer-emu8e4"  data-framer-component-type="RichTextContainer">
                                        <h3
                                            
                                            class="framer-text rict"
                                        >
                                            <span>3</span> 
                                        </h3>
                                    </div>
                                    <div class="framer-8uq5u9">
                                        <div class="framer-n6dn7u"  data-framer-component-type="RichTextContainer">
                                            <h3
                                               
                                                class="framer-text ghme1"
                                            >
                                                  Cadence of Service
                                            </h3>
                                        </div>
                                        <div class="framer-rof8e4"  data-framer-component-type="RichTextContainer">
                                            <p
                                               
                                                class="framer-text ghme1"
                                            >
                                               Depending on the frequency of contact you opt for, we will be in regular contact using your preferred means, making sure that there are no panicked calls at the end of a quarter or fiscal year.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="framer-1ua1v30 sectiononeb hide" data-framer-name="Card" id="section-4" name="Card" >
                                <div class="framer-d7t0r0">
                                    <div class="framer-dqpczu"  data-framer-component-type="RichTextContainer">
                                        <h3
                                           
                                            class="framer-text rict"
                                        >
                                           <span>4</span> 
                                        </h3>
                                    </div>
                                    <div class="framer-fs6qph">
                                        <div class="framer-n6dn7u"  data-framer-component-type="RichTextContainer">
                                            <h3
                                               
                                                class="framer-text ghme1"
                                            >
                                                  Lorem Ipsum
                                            </h3>
                                        </div>
                                        <div class="framer-rof8e4"  data-framer-component-type="RichTextContainer">
                                            <p
                                               
                                                class="framer-text ghme1"
                                            >
                                               Lorem Ipsum is simply dummy text of the printing and typesetting industry
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

      <div class="framer-lubqzj container" data-framer-name="Reviews" id="reviews" name="Reviews">
    <div class="framer-tmpdlg" >
        <div class="framer-1duj7ta" data-framer-name="Card" name="Card">
            <div class="framer-1fq3ys4">
                <div class="framer-1askam5">
                    <div class="framer-oypnlo">
                        <div >
                            <img
                                decoding="async"
                                sizes="80px"
                                
                                src="/assets/images/home4/Devon.jpeg"
                                alt=""
                               
                            />
                        </div>
                    </div>
                    <div class="framer-gmk5zc">
                        <div class="ssr-variant hidden-v14nzn">
                            <div class="framer-11dglge"  data-framer-component-type="RichTextContainer">
                                <div class="label pad gradient homet">Testimonial</div>
                                <h2
                                    
                                    class="framer-text cms-heading margin-top-0px"
                                >
                                    Devon Gustafson 
                                </h2>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <div class="framer-1mi5571">
                    <div class="framer-1ohazg3">
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                            
                            class="framer-fj5n9m rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                           
                            class="framer-7cbzvc rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                            
                            class="framer-1uik7ta rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                           
                            class="framer-1jukhlw rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                            
                            class="framer-1raveq rateinf3" 
                            aria-hidden="true"
                        ></div>
                    </div>
                    
                    <div class="framer-r48h0g"  data-framer-component-type="RichTextContainer">
                        <p
                            
                            class="framer-text"
                        >
                            Christopher and his colleagues are by far the most loyal and professional team of tax I have ever dealt with. They know how to take care of small business people like myself with craft and professionalism. I highly recommend this company for anyone looking for tax help and bookkeeping.
                        </p>
                    </div>
                </div>
            </div>
            <div class="framer-s852co">
                
                <a
                    data-framer-component-type="SVG"
                    data-framer-name="icons8_linkedin_1"
                    name="icons8_linkedin_1"
                    href="https://www.linkedin.com/in/yehor-herasymchuk/"
                    target="_blank"
                    rel="noopener"
                    
                    class="framer-1atzp7n framer-1bofbcw"
                    aria-hidden="true"
                >
                    <div class="svgContainer">
                        <svg ><use href="#svg9562390086"></use></svg>
                    </div>
                </a>
                
            </div>
        </div>
          <div class="framer-17i0gfk" data-framer-name="Card" name="Card"> 
            <div class="framer-1fq3ys4">
                <div class="framer-1askam5">
                    <div class="framer-oypnlo io">
                        <div >
                            <img
                                decoding="async"
                                sizes="80px"
                               
                                src="/assets/images/home4/alex.jpeg"
                                alt=""
                               
                            />
                        </div>
                    </div>
                    <div class="framer-gmk5zc">
                        <div class="ssr-variant hidden-v14nzn">
                            <div class="framer-11dglge"  data-framer-component-type="RichTextContainer">
                                <div class="label pad gradient homet">Testimonial</div>
                                <h2
                                    
                                    class="framer-text cms-heading margin-top-0px"
                                >
                                    Alex Cummings
                                </h2>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <div class="framer-1mi5571">
                    <div class="framer-1ohazg3">
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                            
                            class="framer-fj5n9m rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                           
                            class="framer-7cbzvc rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                            
                            class="framer-1uik7ta rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                           
                            class="framer-1jukhlw rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                            
                            class="framer-1raveq rateinf3"
                            aria-hidden="true"
                        ></div>
                    </div>
                    
                    <div class="framer-r48h0g"  data-framer-component-type="RichTextContainer">
                        <p
                            
                            class="framer-text"
                        >
                            Chris and his team at Royalty Tax are fantastic! They made submitting my tax documents a breeze. Their clear instructions and communication ensured I didn't miss anything. They kept me informed about deadlines and promptly addressed any questions that arose during filing. This is my third year using them, and they've been invaluable. They've handled my family's complex filing situations with expertise, even during the challenges of the pandemic.
                        </p>
                    </div>
                </div>
            </div>
            <div class="framer-s852co">
                
                <a
                    data-framer-component-type="SVG"
                    data-framer-name="icons8_linkedin_1"
                    name="icons8_linkedin_1"
                    href="#"
                    target="_blank"
                    rel="noopener"
                    
                    class="framer-1atzp7n framer-1bofbcw"
                    aria-hidden="true"
                >
                    <div class="svgContainer">
                        <svg ><use href="#svg9562390086"></use></svg>
                    </div>
                </a>
                
            </div>
        </div>

         <div class="framer-17i0gfk" data-framer-name="Card" name="Card"> 
            <div class="framer-1fq3ys4">
                <div class="framer-1askam5">
                    <div class="framer-oypnlo io">
                        <div >
                            <img
                                decoding="async"
                                sizes="80px"
                               
                                src="/assets/images/home4/drew.jpeg"
                                alt=""
                               
                            />
                        </div>
                    </div>
                    <div class="framer-gmk5zc">
                        <div class="ssr-variant hidden-v14nzn">
                            <div class="framer-11dglge"  data-framer-component-type="RichTextContainer">
                                <div class="label pad gradient homet">Testimonial</div>
                                <h2
                                    
                                    class="framer-text cms-heading margin-top-0px"
                                >
                                   Drew Sanden
                                </h2>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <div class="framer-1mi5571">
                    <div class="framer-1ohazg3">
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                            
                            class="framer-fj5n9m rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                           
                            class="framer-7cbzvc rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                            
                            class="framer-1uik7ta rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                           
                            class="framer-1jukhlw rateinf3"
                            aria-hidden="true"
                        ></div>
                        <div
                            data-framer-component-type="SVG"
                            data-framer-name="graphic"
                            name="graphic"
                            
                            class="framer-1raveq rateinf3"
                            aria-hidden="true"
                        ></div>
                    </div>
                    <div class="framer-1m1n3de"  data-framer-component-type="RichTextContainer">
                        <p
                            
                            class="framer-text"
                        >
                        We operate a growing coworking company in Southern California with over 10 operating entities. Royalty Tax has been a reliable and responsive partner, specifically in providing bookkeeping and tax services. We've referred them to several outside companies and their experiences have been consistent with ours. Highly recommend their services.
                        </p>
                    </div>
                   
                </div>
            </div>
            <div class="framer-s852co">
                
                <a
                    data-framer-component-type="SVG"
                    data-framer-name="icons8_linkedin_1"
                    name="icons8_linkedin_1"
                    href="#"
                    target="_blank"
                    rel="noopener"
                    
                    class="framer-1atzp7n framer-1bofbcw"
                    aria-hidden="true"
                >
                    <div class="svgContainer">
                        <svg ><use href="#svg9562390086"></use></svg>
                    </div>
                </a>
                
            </div>
        </div>
        </div></div>

      <div class="connecting-trends first-trends last hide">
         <div class="container">
            <div class="row align-items-center rotate-in-mobile">
            <div class="col-md-6">
              
                     </div> 
            
            
            <div class="col-md-6">
               <div class="section-content">
               <h2 class="heading-3"> <span class="eyebrow">Lorem Ipsum</span> 
               </h2>
                <h2>Lorem Ipsum <br/>is dummy text.</h2>
                  
                  
                <div class="upperd">
                     <p class="cta-link link"><a href="/signup" class="btn-link">Initiate Consultation&nbsp; </a></p>
                     </div>
               </div> </div>
            </div>

            </div>
      </div>
      </div> 
      






<Footer/>

   

<div class="row -center hero-row popupde">
    <div class="close2">
        <a class="close-atag" href="javascript:void(0);">
            <img src="/assets/images/xlose.png" />
        </a>
    </div>
<img class="feature-callout__img" src="https://luna1.co/005100.png" alt="Image of team" width="112" />
            <div class="signupForm-homepage-center col-xsmall-12 col-small-8 col-small-offset-2 col-medium-10 col-medium-offset-1 col-large-8 col-large-offset-2 col-xlarge-6 col-xlarge-offset-3">
                <h4 class="heading -spacing-2 -h3">Sign up</h4>
                <p class="subheading -spacing-1 hero-legal-copy">
                    By signing up, I agree to the Asana <a href="/terms#privacy-policy" class="css-1kfjk3x-Link">Privacy Policy</a> and <a href="/terms#terms-of-service" class="css-1kfjk3x-Link">Terms of Service</a>.
                </p>
                <form action="get-started/verify" method="get" novalidate="" class="signupForm hidden-logged-in signupForm-homepage-center" __bizdiag="1239199729" __biza="WJ__">
                    <div class="signupForm-container">
                        <div class="signupForm-row">
                        <div class="form-group">
                                
                                <input type="email" name="e" required  class="form-control" placeholder="name@company.com" id="work-email" />
                            </div>

                            <div class="submit-btn">
                                <button id="go-to-nextStep"  onClick={this.toggleBox} class="btn btn-lg btn-flat btn-block btn-primary">Next</button>
                            </div>
                        </div>
                    </div>
                </form>
                
            </div>
        </div>
    </div>
    );
}
}

export default Blockproducers;
